export { default } from './SvgIcon';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/SvgIcon/index.js
// module id = 159
// module chunks = 121